import initialize from 'ember-modal-dialog/instance-initializers/add-modals-container';

export default {
  name: 'add-modals-container',
  initialize,
};
